export default __webpack_public_path__ + "static/petiteMaro2.inspirations-dbadda5634aed6514091de97321bcb4b.jpg";